import type { TooltipProps } from 'platform/components';
import type { RowData } from '../types/RowData';
import type { EagRowNode } from '../types/RowGetter';
import type { TooltipGetter } from '../types/TooltipGetter';
const TOOLTIP_OPEN_DELAY = 500;

/**
 * Computes TooltipProps for a cell/row by calling the consumer-provided
 * propsGetter and applying defaults (openDelay, isDisabled when no content).
 *
 * This is a pure function — NOT a hook. It has zero React hook calls.
 */
export const getTooltipProps = (data: RowData, node: EagRowNode, propsGetter?: TooltipGetter): TooltipProps => {
  const tooltipProps: TooltipProps = propsGetter ? propsGetter({
    data,
    node
  }) : {} as TooltipProps;
  const haveContent = tooltipProps.label !== undefined || tooltipProps.description !== undefined;
  const isDisabled = tooltipProps.isDisabled ?? !haveContent;
  return {
    openDelay: TOOLTIP_OPEN_DELAY,
    ...tooltipProps,
    isDisabled
  };
};